import Select from 'react-select'

const SelectCRM = ({ label, value, callback, style, opt }) => {
  return (
    <>
      <label>{label}</label>
      <Select
        options={opt}
        styles={style}
        placeholder={'Select...'}
        menuPlacement="auto"
        isSearchable={false}
        value={opt.find((f) => f.value === value) || ''}
        onChange={callback}
      />
    </>
  )
}

export default SelectCRM
